function isMobile() {
  // Simple check, you can improve with more sophisticated detection if needed
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
export default isMobile;
